// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-plans.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-plans/flight-plan-filing-procedure.js';
import g1 from '../lessons/air-law/flight-plans/flight-plan-international-customs.js';
import g2 from '../lessons/air-law/flight-plans/flight-plans.js';

mount([g0, g1, g2]);
